import React from "react";

const ComingSoon = ({ isDarkMode }) => {
    return (
        <div className={`flex-1 flex flex-col items-center justify-center p-6 text-center ${isDarkMode ? "bg-gray-950" : "bg-gray-50"} h-full overflow-hidden`}>
            <div className="max-w-xl w-full">
                {/* Animated Icon */}
                <div className="mb-8 relative inline-block">
                    <div className="absolute inset-0 bg-cyan-500 blur-2xl opacity-20 rounded-full animate-pulse"></div>
                    <div className={`relative w-24 h-24 mx-auto rounded-3xl flex items-center justify-center ${isDarkMode ? "bg-gray-900 border border-gray-800" : "bg-white border border-gray-100"
                        } shadow-xl transform hover:scale-105 transition-transform duration-500`}>
                        <svg
                            className="w-12 h-12 text-cyan-500 animate-bounce"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            style={{ animationDuration: '2s' }}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19.428 15.428a2 2 0 00-1.022-.547l-2.384-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                            ></path>
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h1 className={`text-4xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-600`}>
                    Coming Soon
                </h1>

                {/* Description */}
                <p className={`text-lg md:text-xl mb-8 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
                    We're crafting something extraordinary for the Discovery feature. Stay tuned for a revolutionary experience.
                </p>

                {/* Notification / Interest Form (Mock) */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
                    <div className={`px-4 py-2 rounded-full text-sm font-medium ${isDarkMode ? "bg-cyan-500/10 text-cyan-400 border border-cyan-500/20" : "bg-cyan-50 text-cyan-600 border border-cyan-100"
                        }`}>
                        🚀 Launching shortly
                    </div>
                    <div className={`px-4 py-2 rounded-full text-sm font-medium ${isDarkMode ? "bg-blue-500/10 text-blue-400 border border-blue-500/20" : "bg-blue-50 text-blue-600 border border-blue-100"
                        }`}>
                        ✨ Premium Features
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
